(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const inEditor = Boolean(window.Shopify && window.Shopify.designMode);
  const reveal = () => root.classList.remove('gj-page-entering', 'gj-page-leaving');

  if (inEditor || reduceMotion.matches) {
    reveal();
  } else {
    const showPage = () => {
      const leadImage = document.querySelector('main img[loading="eager"], main img:not([loading])');
      const imageReady = leadImage && !leadImage.complete && leadImage.decode
        ? leadImage.decode().catch(() => {})
        : Promise.resolve();
      Promise.all([
        new Promise(resolve => setTimeout(resolve, 300)),
        Promise.race([imageReady, new Promise(resolve => setTimeout(resolve, 650))]),
      ]).then(() => {
        requestAnimationFrame(() => requestAnimationFrame(reveal));
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showPage, { once: true });
    else showPage();
  }

  window.addEventListener('pageshow', event => { if (event.persisted) reveal(); });
  document.addEventListener('click', event => {
    if (inEditor || reduceMotion.matches || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target && link.target !== '_self' || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !['http:', 'https:'].includes(url.protocol) || url.pathname === location.pathname && url.search === location.search) return;
    if (url.pathname.startsWith('/checkout') || url.pathname.startsWith('/cart')) return;
    event.preventDefault();
    root.classList.add('gj-page-leaving');
    location.href = url.href;
    setTimeout(() => root.classList.remove('gj-page-leaving'), 1500);
  });
})();
